import { render, staticRenderFns } from "./Glazes.vue?vue&type=template&id=159362a4"
import script from "./Glazes.vue?vue&type=script&lang=js"
export * from "./Glazes.vue?vue&type=script&lang=js"
import style0 from "./Glazes.vue?vue&type=style&index=0&id=159362a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports